const initialState = {
  responses: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "FETCHED_RESPONSE":
      return {
        ...state,
        responses: action.data,
      };
    case "ADDED_RESPONSE":
      return { ...state, responses: [action.data].concat(state.responses) };
    case "UPDATED_RESPONSE":
      return {
        ...state,
        responses: state.responses.map((response) =>
          response.id === action.data.id ? action.data : response
        ),
      };
    case "DELETED_RESPONSE":
      return {
        ...state,
        responses: state.responses.filter((response) => response.id !== action.responseId),
      };
    default:
      return state;
  }
};
